import { Utils } from '@genial/utils';

import { FeatureToggle } from '../../../../../../utils/useUnleashFlags';

import { AssetNoticesNormalized } from '.';

export const onlyHighRiskInvestorsNoticeEquity: AssetNoticesNormalized = {
  id: 'onlyHighRiskInvestorsNoticeEquity',
  backgroundColor: Utils.ColorToken.WithOpacity('feedback.attention.lightest', 'opacity.medium'),
  type: 'warning',
  ableToClose: true,
  textObjects: [
    { text: 'Atenção: ', variant: 'bold' },
    { text: 'Apenas clientes ', variant: 'regular' },
    { text: 'ARROJADOS ', variant: 'bold' },
    {
      text: 'podem investir em renda variável. Os valores apresentados nesta pré-boleta estão sujeitos a variações de mercado, não contemplam custos operacionais como corretagem, emolumentos ou outros.',
      variant: 'regular',
    },
  ],
};

export const warningOperatingCostsInvestorsNoticeEquity: AssetNoticesNormalized = {
  id: 'warningOperatingCostsInvestorsNoticeEquity',
  backgroundColor: Utils.ColorToken.WithOpacity('feedback.attention.lightest', 'opacity.medium'),
  type: 'warning',
  ableToClose: false,
  textObjects: [
    {
      text: 'Atenção: ',
      variant: 'bold',
    },
    {
      text: 'Para o envio de ordens de renda variável serão aplicadas tarifas, conforme os custos e tarifas da Genial Investimentos. Para maiores detalhes, consulte as informações completas no ',
      variant: 'regular',
    },
    {
      text: 'link disponível aqui.',
      variant: 'link',
      onPress: () =>
        window.open('https://www.genialinvestimentos.com.br/custos-tarifas/', '_blank'),
    },
  ],
  unleashFlag: FeatureToggle.MessageAlertOperatingCostsEquities,
};

export const onlyHighRiskInvestorsNoticeCoes: AssetNoticesNormalized = {
  id: 'onlyHighRiskInvestorsNoticeCoes',
  backgroundColor: Utils.ColorToken.WithOpacity('feedback.attention.lightest', 'opacity.medium'),
  type: 'warning',
  ableToClose: true,
  textObjects: [
    { text: 'Atenção: ', variant: 'bold' },
    {
      text: 'Apenas clientes com um perfil de investimento classificado como ',
      variant: 'regular',
    },
    { text: 'ARROJADO ', variant: 'bold' },
    {
      text: 'estão habilitados para realizar investimentos em operações estruturadas.',
      variant: 'regular',
    },
  ],
};

export const limitedOrderNotice: AssetNoticesNormalized = {
  id: 'limitedOrderNotice',
  type: 'alert',
  ableToClose: false,
  batchTicketOnly: true,
  textObjects: [
    { text: 'Este produto será enviado em uma ordem do tipo ', variant: 'regular' },
    { text: 'limitada', variant: 'bold' },
    {
      text: ', para continuar, é necessário que você informe a quantidade ou o preço por ativo. Em seguida, clique em selecionar.',
      variant: 'regular',
    },
  ],
};
